import React from "react";
import styled from "styled-components";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const Header = ({ text, onClose }) => {
  const classes = useStyles();
  return (
    <Container>
      <Typography className={classes.root}>{text}</Typography>
    </Container>
  );
};

export default Header;

const Container = styled.div`
  background: var(--surface-50);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.3em 0;
  height: 60px;
`;

const useStyles = makeStyles((theme) => ({
  root: {
    color: "var(--text-primary)",
    marginLeft: "1em",
  },
  icon: {
    color: "var(--White)",
    opacity: 0.6,
  },
}));
